const debug = localStorage.getItem("debug") == "true" || false;
let url = process.env.URL_API || "https://portal.credi10.com.co/";
if (debug) {
    url = "https://portalqa.credi10.com.co";
}
    
export const endpoints = {
    GRAPHQL_AUTH: `${url}/api/auth`,
    
    GRAPHQL_GENERAL: `${url}/api/data`,
    CREDI10_SIGNUP: 'https://www.credi10.com.co/originacioncredi10/',
    CREDI10_CONTACTUS: 'https://clientes.credi10.com.co/contactenos//',
    CREDI10_PAYMENT_LINK: 'https://credi10.com.co/',
    CREDI10_PQRS: 'https://pqrs.credi10.com.co/',
    CREDI10_CLIENTS: 'https://clientes.credi10.com.co/'
}

export const captcha = {
    REACT_APP_SITE_KEY: '6LeShQgoAAAAAGPXVzqxdnGqe4S9hKjShfDS4xwc'
}